import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SavedViewsFilterControls } from '~/components/ui/SavedViewsFilterControls';
import { buyListFilterFields } from '~/pages/buy-lists/lib/buyListFilterFields';
import { activeRowCount } from '~/pages/buy-lists/lib/buyListFilters';
import type { BuyListSavedViews } from '~/pages/buy-lists/lib/useBuyListSavedViews';
import { BuyListFilterPanel } from './BuyListFilterPanel';

type BuyListFilterControlsProps = {
  readonly locations: { label: string; value: string }[];
  readonly transportVehicles: { label: string; value: string }[];
  readonly products: { label: string; value: string }[];
  readonly isLoadingProducts: boolean;
  readonly views: BuyListSavedViews;
};

export function BuyListFilterControls({
  locations,
  transportVehicles,
  products,
  isLoadingProducts,
  views,
}: BuyListFilterControlsProps) {
  const { t } = useTranslation('inventory');

  const fieldOptions = useMemo(
    () => buyListFilterFields(t, { locations, transportVehicles }),
    [t, locations, transportVehicles]
  );

  return (
    <div className="flex items-center gap-4">
      <SavedViewsFilterControls
        namespace="inventory"
        keyPrefix="inventory.buy_list.filter"
        views={views}
        activeCount={activeRowCount(views.rows)}
        buttonTestId="buy-list-filter-button"
        countTestId="buy-list-filter-count"
        renderPanel={({ maxHeight, bottomContent }) => (
          <BuyListFilterPanel
            maxHeight={maxHeight}
            bottomContent={bottomContent}
            rows={views.rows}
            fieldOptions={fieldOptions}
            productOptions={products}
            isLoadingProducts={isLoadingProducts}
            onRowsChange={views.setRows}
          />
        )}
      />
    </div>
  );
}
